import { TableItem } from 'components/atoms';
import Table from 'components/organisms/table/Table';
import { useCustomParamId } from 'hooks/useParamId';
import { useTranslation } from 'react-i18next';
import { useGetMusicProductDigitalAssetId } from 'services/music-product-digital/assetId';

const MusicProductDigitalAssetIds = () => {
  const productId = useCustomParamId('id', '/music-product-digital');

  const { t } = useTranslation();

  const assets = useGetMusicProductDigitalAssetId(productId);
  return assets.isLoading ? (
    <Table
      id={'MusicProductDigitalTrackAssets'}
      size='compact'
      loading
      data={{
        nodes: [],
      }}
      columns={[
        {
          label: '',
          renderCell: () => null,
        },
      ]}
    />
  ) : (
    <div className='flex w-full flex-col gap-4'>
      {assets.data?.map(track => (
        <Table
          id={'MusicProductDigitalTrackAssets'}
          size='compact'
          displayMode
          data={{
            nodes: track.assetIds.map((asset, index) => ({
              asset: asset,
              id: index,
            })),
          }}
          columns={[
            {
              label: `${track.title} ${
                track.titleVersion ? ` - ${track.titleVersion}` : ''
              }`,
              renderCell: ({ asset }) => (
                <TableItem>
                  <TableItem.Text text={asset} />
                </TableItem>
              ),
            },
          ]}
        />
      ))}
    </div>
  );
};

export default MusicProductDigitalAssetIds;
